import { SiteStatusAction } from './actions';

export interface SiteStatusState {
  branchStatusList: Array<{
    id: string;
    status: string;
  }>;
  loadingError: string;
  loading?: boolean;
  saving?: boolean;
  savingExpectedCount: number;
  savingFailedIDs: string[];
  savingSuccessfulIDs: string[];
}

const initialState: SiteStatusState = {
  branchStatusList: [],
  loading: false,
  loadingError: '',
  saving: false,
  savingExpectedCount: 0,
  savingSuccessfulIDs: [],
  savingFailedIDs: [],
};

const siteStatusReducer = (
  state: SiteStatusState = initialState,
  action: SiteStatusAction,
): SiteStatusState => {
  switch (action.type) {
    case 'GET_STATUSES_REQUEST': {
      return {
        ...state,
        loading: true,
        loadingError: '',
      };
    }

    case 'GET_STATUSES_SUCCESS': {
      return {
        ...state,
        branchStatusList: action.payload,
        loading: false,
        loadingError: '',
      };
    }

    case 'GET_STATUSES_FAILURE': {
      return {
        ...state,
        loading: false,
        loadingError: 'load_error',
      };
    }

    case 'UPDATE_STATUS_EXPECTED_COUNT': {
      return {
        ...state,
        saving: true,
        savingExpectedCount: action.payload,
        savingFailedIDs: [],
        savingSuccessfulIDs: [],
      };
    }

    case 'UPDATE_STATUS_SUCCESS': {
      return {
        ...state,
        savingSuccessfulIDs: [action.extra.id, ...state.savingSuccessfulIDs],
        saving:
          state.savingExpectedCount >
          state.savingSuccessfulIDs.length + state.savingFailedIDs.length + 1,

        branchStatusList: state.branchStatusList.map((branchStatus) => {
          if (branchStatus.id === action.extra.id) {
            return {
              ...branchStatus,
              status: action.extra.status,
            };
          }
          return branchStatus;
        }),
      };
    }

    case 'UPDATE_STATUS_FAILURE': {
      return {
        ...state,
        savingFailedIDs: [action.extra.id, ...state.savingFailedIDs],
        saving:
          state.savingExpectedCount >
          state.savingSuccessfulIDs.length + state.savingFailedIDs.length + 1,
      };
    }

    default:
      return { ...state };
  }
};

export default siteStatusReducer;
